export enum LocalStorageKeys {
  USER_NAME = 'manager-studio-username',
  CURRENT_PASSWORD = 'manager-studio-current-password',
  SELECTED_COMPANY_ID = 'manager-studio-selected-company-id',
  SELECTED_PROJECT_ID = 'manager-studio-selected-project-id',
  SELECTED_PROJECT_NAME = 'manager-studio-selected-project-name',
  LOGIN_PROJECT_NAME = 'manager-studio-login-project-name',
  SSO_REDIRECT_URL = 'manager-studio-sso-redirect-url',
}
